import React from 'react';
import './banner.scss';
import TestButton from '../TestButton/testbutton';

function Banner({ children }) {
  return (
    <div className="banner">
      {children}
      <div style={{ display: 'flex', flexDirection: 'row', gap: '.8rem' }}>
        <TestButton
          variant="secondary"
          onClick={() => {
            // Remove "scrolling-up" and add "scrolling-down" after 1 second
            setTimeout(() => {
              document.body.classList.remove("scrolling-up");
              document.body.classList.add("scrolling-down");
          }, 1000); // 1 second delay
  
            const contactSection = document.getElementById('services'); // Get the #contact section
            if (contactSection) {
              const offset = 0; // Set your desired offset (e.g., 100px)
              const elementPosition = contactSection.getBoundingClientRect().top + window.scrollY;
              const offsetPosition = elementPosition - offset;
  
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth', // Smooth scrolling
              });
            }
          }}
        >
          Services
        </TestButton>
        <TestButton
          variant="primary"
          onClick={() => {
            // Remove "scrolling-up" and add "scrolling-down" after 1 second
            setTimeout(() => {
              document.body.classList.remove("scrolling-up");
              document.body.classList.add("scrolling-down");
          }, 1000); // 1 second delay
  
            const contactSection = document.getElementById('contact'); // Get the #contact section
            if (contactSection) {
              const offset = 0; // Set your desired offset (e.g., 100px)
              const elementPosition = contactSection.getBoundingClientRect().top + window.scrollY;
              const offsetPosition = elementPosition - offset;
  
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth', // Smooth scrolling
              });
            }
          }}
        >
          Contact
        </TestButton>
      </div>
    </div>
  );
}

export default Banner;